export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const TOKENWORKS_ADDRESS = '0x1244EAe9FA2c064453B5F605d708C0a0Bfba4838';
export const PUNKAUCTION_ADDRESS = '0x489f2913588cC34De20fE55Ee1130529656A6625';
